import type { MessageType } from "@expert/shared-types";

export const botMessageTypes: MessageType[] = [
    "Proactive",
    "Search",
    "Default",
    "Error",
    "Connection",
    "SessionSummary",
    "GuideRecommendation",
    "SalesGuidance",
    "SalesMessage",
];
export const isFromBot = (type: MessageType) => botMessageTypes.includes(type);

export const isFromExpert = (type: MessageType) => type === "Expert";
